/** Restrict post-login redirects to in-app relative paths. */
export function sanitizeNextPath(next: string | null | undefined, fallback = '/') {
  if (!next || !next.startsWith('/') || next.startsWith('//')) {
    return fallback;
  }

  return next;
}
